import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function ComplianceTemplate({ title, subtitle, dateInfo, content }) {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                backgroundColor: '#2253A2',
                minHeight: '100vh',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {/* Top white navbar */}
            <Box
                sx={{
                    backgroundColor: 'white',
                    height: '8%',
                    minHeight: '56px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    px: 2,
                    boxShadow: 1,
                }}
            />

            {/* Main white content box */}
            <Box
                sx={{
                    backgroundColor: 'white',
                    borderRadius: 2,
                    boxShadow: 3,
                    mx: 'auto',
                    my: 4,
                    px: { xs: 3, sm: 5, md: 6 },
                    py: { xs: 4, sm: 6 },
                    width: '100%',
                    maxWidth: '90%',
                    height: '100%',
                    overflowY: 'auto',
                }}
            >
                {/* Back button */}
                <Box display="flex" justifyContent="flex-end" mb={3}>
                    <Button
                        onClick={() => navigate(-1)}
                        sx={{
                            border: '1px solid #999',
                            borderRadius: 0,
                            minWidth: '10%',
                            padding: '2',
                            color: '#000',
                            fontWeight: 500,
                            textTransform: 'none',
                            backgroundColor: '#f2f2f2',
                            fontSize: '15px',
                            boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: '#e0e0e0',
                            },
                        }}
                    >
                        Back
                    </Button>
                </Box>

                {/* Page Title */}
                <Typography
                    variant="h5"
                    gutterBottom
                    sx={{
                        fontFamily: '"Syncopate", sans-serif',
                        textTransform: 'uppercase',
                    }}
                >
                    {title}
                </Typography>


                {/* Optional subtitle/date */}
                {dateInfo && (
                    <Typography variant="body2" color="text.secondary" mb={3} >
                        {dateInfo}
                    </Typography>
                )}

                {/* Dynamic Content */}
                <Box>
                    {content}
                </Box>
            </Box>
        </Box>
    );
}
